import { connect } from 'react-redux'
import CloseModalButton from 'components/CloseModalButton'
import { setSignUpModalIsOpen } from 'redux/actions'

const mapStateToProps = (state) => ({
  controller: state.layout.controller
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(CloseModalButton)
